export const timeZeroGameList = [
  'e11000000297',
  'e76337e746e1f95fdbf7e23c26010e448',
];

// 王者荣耀世界 HOK World 游戏 id
export const HOK_WORLD_GAME_ID = 'u7c29230c87aff69d11da9384e78e8b0f';

// GST 游戏 id
export const GST_GAME_ID = 'u10000000075';

// 抖音直播 DLTB 游戏 id
export const DLTB_GAME_ID = 'e11000000344';

export const POE2 = ['e7f672beaa5fddd166df98bc046ba4bd4'];

export const HOURLYUPDATEPAGE = ['/opinion/Overview'];
